// training-mode-banner.component.ts
import { Component, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { StoreService } from '../_services/store.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-training-mode-banner',
  templateUrl: './training-mode-banner.component.html',
  styleUrls: ['./training-mode-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingModeBannerComponent implements OnDestroy {
  private sub: Subscription;

  constructor(public store: StoreService) {
    this.sub = this.store.trainingModUpdate.subscribe(on => {
      document.body.classList.toggle('training-on', !!on);
    });
  }

  ngOnDestroy(){ this.sub?.unsubscribe(); }
}
